/* template */
<template><mpx-view @tap="onClick" v-if="(titleText && titleText.length)"><div :class='("tips-main "+(type==="order"?"order":""))'><div class="tips-left"><div class="tips-title" v-if="(noticeTitle)">{{noticeTitle}}</div><div class="tips-content">{{ titleText }}</div></div><div class="tips-right"><mpx-image src="https://ut-static.udache.com/webx/sfc/SurrbhwdBTSNdfKCJ6aCW.png" class="angle-right"/></div></div></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m87cd944c"}'>
  .tips-main
    height 33px
    box-sizing border-box
    display flex
    align-items center
    background #FFF0EE
    margin 0 8px 8px
    font-family PingFangSC-Regular
    font-size 12px
    border-radius 8px
    line-height 14px
    &.order
      margin 0
      color #333333
      .tips-content
        color #222
  .tips-icon
    margin-right 4px
  .tips-left
    width calc(100% - 40px)
    font-weight normal
    display flex
    margin-left 12px
  .tips-title
    flex none
    color #FF4129
    white-space nowrap
    text-overflow ellipsis
    margin-right 4px
  .tips-content
    flex 1
    overflow hidden
    white-space nowrap
    text-overflow ellipsis
    color #FF6221
  .tips-right
    width 20px
    margin 0 4px
    line-height 20px
    text-align center
    align-content center
    .angle-right
      width 12px
      height 12px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m87cd944c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./noticeTip.mpx.js?isComponent&outputPath=components%2FnoticeTip87cd944c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./noticeTip.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2FnoticeTip87cd944c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m87cd944c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/noticeTip87cd944c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
